import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { sendPasswordResetEmail } from "firebase/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase.js";

import { Button, FormControl } from "@mui/material";

export default function Forgot() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const handleEmailchange = (event) => {
    setEmail(event.target.value);
  };

  const handleReset = async () => {
    if (!email) {
      setMessage("Please enter your email.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Password reset email sent! Check your inbox.");
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          p: 2,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          margin: "auto",
          width: "20rem",
          justifyContent: "center",
          alignItems: "center",
          overflowY: "hidden",
          overflowX: "hidden",
          gap: 1,
          alignSelf: "center",
          justifySelf: "center",
        }}
      >
        <Typography
          style={{
            textAlign: "center",
            marginTop: "2rem",
            color: "Gray",
          }}
          variant="h6"
          gutterBottom
        >
          Reset Passoword
        </Typography>
        <Typography
          style={{
            textAlign: "center",
            color: "red",
          }}
          variant="body2"
          gutterBottom
        >
          {message}
        </Typography>
        <FormControl>
          <TextField
            onChange={handleEmailchange}
            value={email}
            name="email"
            required
            id="outlined-email-input"
            label="Email"
            type="email"
            variant="filled"
            style={{ margin: "0.5rem", marginTop: "1rem" }}
          />
        </FormControl>
        <Button
          onClick={handleReset}
          variant="contained"
          color="primary"
          size="large"
          fullWidth
        >
          Reset
        </Button>
        <Button
          onClick={() => navigate("/signup")}
          variant="contained"
          color="primary"
          size="large"
          fullWidth
        >
          Login Instead
        </Button>
      </Box>
    </Box>
  );
}
